/**
 * Seed mock MBF projects (5 entries per DP-04). Loaded into
 * `state.scratchGui.myProjects.list` initial state. Each entry has
 * `vmState: null` so Phase 3 "fake-load" strategy (DP-05) resets workspace
 * to default Scratch project + sets project title.
 *
 * Marked `isMock: true` so app-state hydration can detect first-boot vs
 * user-cleared state.
 *
 * BE team will replace this import with a real /projects API endpoint.
 */

const MOCK_PROJECTS = [
    {
        id: 'mbf-robot-line-01',
        name: 'Robot Bám Vạch 01',
        type: 'robot',
        description: 'Robot di chuyển theo đường vạch đen sử dụng cảm biến sharpIR + l298n motor driver',
        createdAt: '2026-05-20T08:00:00.000Z',
        updatedAt: '2026-05-25T14:30:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-led-alert-02',
        name: 'Đèn LED Cảnh Báo',
        type: 'robot',
        description: 'Bật/tắt LED + buzzer khi vượt ngưỡng nhiệt độ (DS18B20)',
        createdAt: '2026-05-22T09:15:00.000Z',
        updatedAt: '2026-05-26T10:00:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-rfid-door-03',
        name: 'Hệ Thống Cửa RFID',
        type: 'kit',
        description: 'Mở cửa bằng thẻ RFID — đọc mfrc522 + kích hoạt relay solenoid',
        createdAt: '2026-05-24T11:00:00.000Z',
        updatedAt: '2026-05-28T16:45:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-classroom-sensor-04',
        name: 'Cảm Biến Phòng Học',
        type: 'kit',
        description: 'Dashboard giám sát nhiệt độ + độ ẩm + ánh sáng phòng học (DHT22 + photoresistor)',
        createdAt: '2026-05-26T13:30:00.000Z',
        updatedAt: '2026-06-01T09:20:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-cat-animation-05',
        name: 'Animation Mèo Nhảy',
        type: 'none',
        description: 'Animation Scratch cơ bản — sprite move + costume change theo loop',
        createdAt: '2026-05-28T15:00:00.000Z',
        updatedAt: '2026-06-05T08:00:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-smarthome-relay-06',
        name: 'Bật/tắt đèn qua relay',
        type: 'kit',
        description: 'Bật/tắt đèn qua module relay điều khiển bằng chân digital',
        createdAt: '2026-06-08T08:00:00.000Z',
        updatedAt: '2026-06-10T10:00:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-smarthome-tempalarm-07',
        name: 'Cảnh báo nhiệt độ',
        type: 'kit',
        description: 'Đọc cảm biến nhiệt độ và cảnh báo khi vượt ngưỡng cao',
        createdAt: '2026-06-09T09:30:00.000Z',
        updatedAt: '2026-06-11T14:00:00.000Z',
        vmState: null,
        isMock: true
    },
    {
        id: 'mbf-smarthome-rfiddoor-08',
        name: 'Mở cửa bằng RFID',
        type: 'kit',
        description: 'Đọc thẻ RFID mfrc522 và mở cửa bằng relay khi thẻ hợp lệ',
        createdAt: '2026-06-10T11:00:00.000Z',
        updatedAt: '2026-06-12T16:30:00.000Z',
        vmState: null,
        isMock: true
    }
];

export default MOCK_PROJECTS;
